import { FormattedMessage } from 'react-intl';

interface Props {
  labelId: string;
  onClick: () => void;
}

export default function AuthSwitchLink({ labelId, onClick }: Props) {
  return (
    <div className="text-center">
      <button type="button" onClick={onClick} className="text-sm font-semibold text-brand-700 hover:text-brand-600">
        <FormattedMessage id={labelId} />
      </button>
    </div>
  );
}
